import { Result } from '../../common-models/Result';
import { HttpServiceBase } from '../../common-services/Http/HttpServiceBase';
import { FileRepositoryOutput } from './FileRepositoryOutput';

export class FileRepository extends HttpServiceBase {

    handleOrderImport = (formData: FormData): Promise<Result<FileRepositoryOutput>|null> => {
        const promise = this.http.post<Result<FileRepositoryOutput>, FormData>(`${this.baseUrlFileRepositoryApi}/order-import/new`, formData, true);
        return promise;
    }
}